import React from 'react'
function Sidebar() {
  return (
    <>
      <nav className="sidebar sidebar-offcanvas" id="sidebar" style={{ width: "unset" }}>
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href="index.html">Restro </a>
          <a className="sidebar-brand brand-logo-mini" href="index.html">Restro</a>
        </div>
        <ul className="nav">
         
          <li className="nav-item nav-category">
            <span className="nav-link">Navigation</span>
          </li>
          <li className="nav-item menu-items">
            <a className="nav-link" href="./index">
              <span className="menu-icon">
                <i className="mdi mdi-speedometer"></i>
              </span>
              <span className="menu-title">Dashboard</span>
            </a>
          </li>
          <li className="nav-item menu-items">
            <a className="nav-link" href="./user">
              <span className="menu-icon">
                <i className="mdi mdi-speedometer"></i>
              </span>
              <span className="menu-title">User</span>
            </a>
          </li>
          <li className="nav-item menu-items">
            <a className="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
              <span className="menu-icon">
                <i className="mdi mdi-laptop"></i>
              </span>
              <span className="menu-title">Menu Management</span>
              <i className="menu-arrow"></i>
            </a>
            <div className="collapse" id="ui-basic">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <a className="nav-link" href="./category">Category</a></li>
                <li className="nav-item"> <a className="nav-link" href="./menu">Menu Items</a></li>
              </ul>
            </div>
          </li>
          <li className="nav-item menu-items">
            <a className="nav-link" href="./table">
              <span className="menu-icon">
                <i className="mdi mdi-playlist-play"></i>
              </span>
              <span className="menu-title">Table</span>
            </a>
          </li>
          <li className="nav-item menu-items">
            <a className="nav-link" href="./order">
              <span className="menu-icon">
                <i className="mdi mdi-playlist-play"></i>
              </span>
              <span className="menu-title">Order</span>
            </a>
          </li>
          <li className="nav-item menu-items">
            <a className="nav-link" href="./payment">
              <span className="menu-icon">
                <i className="mdi mdi-playlist-play"></i>
              </span>
              <span className="menu-title">Payment</span>
            </a>
          </li>
          
        </ul>
      </nav>
    </>
  )
}

export default Sidebar
